import JWTService from "./JWTService";
import * as trkl from "trkl";

class ProfileServiceClass {
    sessionExpiring = trkl(false);
    expirationTimestamp = trkl()

    constructor() {
        JWTService.observable.subscribe(this.checkSessionExpiration, true);
        setInterval(this.checkSessionExpiration, 600000);
    }

    checkSessionExpiration = () => {
        const data = JWTService.observable();
        if (!data || !data.hasOwnProperty('refresh_token_expiration_date')) return;
        const timestamp = data.refresh_token_expiration_date;
        if (!timestamp) return;

        const expiration = parseInt(timestamp);
        if (!expiration) return;
        const isExpiring = expiration - ((new Date()).getTime() / 1000) < 7200;
        this.expirationTimestamp(expiration);
        this.sessionExpiring(isExpiring);
    };
}

let ProfileService = new ProfileServiceClass();
export default ProfileService;



// WEBPACK FOOTER //
// ./services/ProfileService.js